module.exports = __webpack_public_path__ + "img/carB.ca098d4b.png";